module.exports = __webpack_public_path__ + "img/about-glories4.c25f58a.png";